/**
 * This function convert a query string into JSON object of key: value pairs
 * @param  {String} url  Converts query params in the URL to json object
 */
module.exports = function _deserialize(url){
  var obj = {},
  queryString = url.split('?')[1],
  queryParamsArr=[];
  if(queryString){
    queryParamsArr = queryString.split('&');
    for(var i=0, l=queryParamsArr.length; i<l;i++) {
      obj[queryParamsArr[i].split('=')[0]] = queryParamsArr[i].split('=')[1];
    }
  }
  return obj;
}